"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AlliedPartyAgenda_vue_1 = require("@/client/components/turmoil/AlliedPartyAgenda.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PlayerAlliedParty',
    props: {
        player: {
            type: Object,
            required: true,
        },
    },
    components: {
        AlliedPartyAgenda: AlliedPartyAgenda_vue_1.default,
    },
});
